import { render, staticRenderFns } from "./FormEventLocation.vue?vue&type=template&id=c6a3cce0&"
import script from "./FormEventLocation.vue?vue&type=script&lang=js&"
export * from "./FormEventLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6a3cce0')) {
      api.createRecord('c6a3cce0', component.options)
    } else {
      api.reload('c6a3cce0', component.options)
    }
    module.hot.accept("./FormEventLocation.vue?vue&type=template&id=c6a3cce0&", function () {
      api.rerender('c6a3cce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormEventLocation.vue"
export default component.exports